import { baseThemeValues } from '../../constants/common';

export const sidebarFieldsTheme = {
  dangerText: 'palette.error.70',
  field: {
    borderColor: 'palette.tertiary.20',
    borderWidth: '1px',
    label: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '14px',
      fontWeight: '600',
      text: 'palette.neutral.90',
    },
  },
  message: {
    info: {
      text: 'palette.neutral.60',
    },
    warning: {
      bg: 'palette.warning.30:0.15',
      borderColor: 'palette.warning.40',
      borderRadius: '8px',
      borderWidth: '1px',
      text: 'palette.warning.95',
    },
  },
};
